export const blogData = [
    {
        id: 1,
        title: 'How to shuffle a matrix elements in C++',
        description: 'We will use the rand() function in C++ to generate random numbers. It generates random numbers in between 0 and RAND_MAX',
        date: 'Jan 15, 2022',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667586048/shuffle_zzwqsa.jpg',
        url: 'https://www.codespeedy.com/shuffle-a-matrix-elements-in-cpp/'
    },
    {
        id: 2,
        title: 'How to generate a random element in C++ from an array',
        description: 'This tutorial discusses how to output a random element from an array in C++',
        date: 'Jan 18, 2022',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667586305/random_bq4eu7.jpg',
        url: 'https://www.codespeedy.com/generate-a-random-element-in-cpp-from-an-array/'
    },
    {
        id: 3,
        title: 'How to quickSort Using Random Pivoting in C++',
        description: 'In this tutorial, we will discuss how to use quicksort using the random pivots in C++.',
        date: 'Jan 21, 2022',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667586459/quicksort_fur9hm.jpg',
        url: 'https://www.codespeedy.com/quicksort-using-random-pivoting-in-cpp/'
    },
    {
        id: 4,
        title: 'How to catch unknown exception and print it in C++',
        description: 'This tutorial will focus on how to handle unknown exceptions and print that in C++.',
        date: 'Jan 23, 2022',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667587546/exception_zoqgyy.jpg',
        url: 'https://www.codespeedy.com/catch-unknown-exception-and-print-it-in-c/'
    },
    {
        id: 5,
        title: 'what is Vector pop_back() in C++ with examples',
        description: 'pop_back() function will remove the last element from the vector. Here the element is removed and the vector size is reduced by 1.',
        date: 'Jan 25, 2022',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667624326/pop_iksvlp.jpg',
        url: 'https://www.codespeedy.com/vector-pop_back-in-cpp-with-examples/'
    },
    {
        id: 6,
        title: 'Uses of initializer List in C++',
        description: 'In C++, an initializer list is used to initialize a class data members. It will begin after the constructor name and its parameters.',
        date: 'Jan 29, 2022',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667624556/init_mymxhd.jpg',
        url: 'https://www.codespeedy.com/uses-of-initializer-list-in-cpp/'
    },
    /*
    {
        id: 7,
        title: 'How to use playsound module in Python',
        description: 'By using playsound module we can play sound. This is a cross platform module that can play audio files.',
        date: 'Jan 15, 2022',
        image: 'https://i.ytimg.com/vi/Wt8VRxUYDso/maxresdefault.jpg',
        url: 'https://www.codespeedy.com/playsound-module-in-python/'
    },
    {
        id: 8,
        title: 'How to install pywhatkit in Python',
        description: 'In this tutorial, we will discuss how to install pywhatkit in Python. Pywhatkit is easy to use and officially supports Python 3.8+',
        date: 'Jan 15, 2022',
        image: 'https://cdn.myedukit.com/wp-content/uploads/python-pywhatkit-768x496.jpg',
        url: 'https://www.codespeedy.com/how-to-install-pywhatkit-in-python/'
    },
    {
        id: 9,
        title: 'How to use randint() Function in Python',
        description: 'In this tutorial, we will discuss how to use randint() function in Python. randint() is an inbuilt function of the random module. By importing random module we can use all of it functions.',
        date: 'Jan 13, 2022',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmZ4CT01OBzrtiJtXmzoHWrp_4dWunrLFmnQ&usqp=CAU',
        url: 'https://www.codespeedy.com/how-to-use-randint-function-in-python/'
    },
    {
        id: 10,
        title: 'How to install Python packages with requirements.txt',
        description: 'we will discuss how to install python packages with requirements.txt file, as it is difficult to install packages individually.',
        date: 'Jan 08, 2022',
        image: 'https://i.ytimg.com/vi/mBcmdcmZXJg/maxresdefault.jpg',
        url: 'https://www.codespeedy.com/how-to-install-python-packages-with-requirements-txt/'
    }
    */
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/